import { render } from "./EditorMedia.vue?vue&type=template&id=07780ea6"
import script from "./EditorMedia.vue?vue&type=script&lang=js"
export * from "./EditorMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__